
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dpp/hotel-concorde/uebernachtung",
      function () {
        return require("private-next-pages/dpp/hotel-concorde/uebernachtung.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dpp/hotel-concorde/uebernachtung"])
      });
    }
  